import { getOptions } from './getOptions';
import { getDefaultAssignmentTypes } from './getDefaultAssignmentTypes';

export const filterUtil = {
  getOptions,
  getDefaultAssignmentTypes
};
